import { useMemo } from "react";
import styled from "styled-components";
import { CatalogRenderer } from "../../common/components/CatalogRenderer";
import {
  Op,
  ProductOpValue,
  OpType,
} from "../../common/components/CatalogRenderer/types";
import { LOGO } from "../../common/LOGO";
import { TradingProductForCatalog } from "../../service/trading";

const Wrap = styled.div`
  background-color: #f5efed;
  height: auto;
  padding: 32px;
  height: auto;
  margin: 64px auto;
  width: 60vw;
  display: flex;
  flex-direction: column;
  @media screen and (width < 800px) {
    width: 100vw;
    margin: 32px 0;
  }
  @media print {
    width: auto;
    height: 100vh;
    padding: 64px;
    padding-bottom: 48px;
    margin: 0;
  }

  .catalog-render-wrap-render {
    padding: 32px 0;
  }
  .catalog-proj-pic {
    width: 240px;
  }
`;

const TitleWrap = styled.div`
  display: flex;
  flex-direction: column;
  color: #d65226;
  gap: 16px;
`;

const Title = styled.div`
  font-size: 32px;
  font-weight: 700;
  line-height: 38px;
`;
const SubTitle = styled.div`
  font-size: 24px;
  font-weight: 400;
  line-height: 28px;
`;

const StyledCatalogRenderer = styled(CatalogRenderer)`
  flex: 1;
`;

const Footer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
`;

const LOGOMini = styled(LOGO)`
  width: 120px;
`;

const Email = styled.div`
  font-weight: 300;
  font-size: 12px;
  line-height: 14px;
  color: #d65226;
`;

export type Product = TradingProductForCatalog & ProductOpValue;
export const Page = ({ products }: { products: Product[] }) => {
  const { pageTitle, pageDescription } = useMemo(() => {
    const query = new URLSearchParams(window.location.search);
    const pageTitle = query.get("page_title");
    const pageDescription = query.get("page_description");
    return { pageTitle, pageDescription };
  }, []);
  const productDisplay: Op[] = useMemo(
    () =>
      products.map((item) => {
        const extra = JSON.parse(item.product_json ?? "");
        return {
          type: OpType.PRODUCT,
          value: { ...item, ...extra },
        };
      }),
    [products]
  );
  return (
    <Wrap>
      <TitleWrap>
        {pageTitle ? <Title>{pageTitle}</Title> : null}
        {pageDescription ? <SubTitle>{pageDescription}</SubTitle> : null}
      </TitleWrap>
      <StyledCatalogRenderer value={productDisplay} imageType="url" />
      <div style={{ flex: 1 }}></div>
      <Footer>
        <LOGOMini />
        <Email>sandy@hihonour.com</Email>
      </Footer>
    </Wrap>
  );
};
